import { useQuery } from "@tanstack/react-query";

import type { ApiClient } from "../client";
import { useApiClient } from "../useApiClient";

import {
  ANALYTICS_QUERY_KEY,
  toAnalyticsQuery,
  type AnalyticsFilters,
} from "./useSummary";

export interface EquityCurveOptions {
  include_deposits?: boolean;
  include_withdrawals?: boolean;
  include_dividends?: boolean;
}

export function equityCurveQueryOptions(
  client: ApiClient,
  filters: AnalyticsFilters = {},
  options: EquityCurveOptions = {},
) {
  return {
    queryKey: [...ANALYTICS_QUERY_KEY, "equity-curve", filters, options],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/analytics/equity-curve", {
        params: {
          query: { ...toAnalyticsQuery(filters), ...options },
        },
      });
      if (error !== undefined) {
        throw new Error("Failed to load equity curve");
      }
      return data;
    },
  };
}

export function useEquityCurve(
  filters: AnalyticsFilters = {},
  options: EquityCurveOptions = {},
) {
  const client = useApiClient();
  return useQuery(equityCurveQueryOptions(client, filters, options));
}
